export const crmHomeCubeAccessRoles: readonly string[] = [
  "crm.admin",
  "crm.supervisor",
  "crm.bi-reader",
  "crm.user",
  "crm.legacy-internal-client",
];

export const hasCrmHomeCubeAccess = (roles: readonly string[]) =>
  crmHomeCubeAccessRoles.some((r) => roles.includes(r));

export const isCrmHomeCubeDirectorAnalytics = (roles: readonly string[]): boolean =>
  roles.includes("crm.admin") || roles.includes("crm.supervisor");

export const canQueryCrmCubeWithoutRegionSelect = (roles: readonly string[]) =>
  roles.includes("crm.user") ||
  roles.includes("crm.bi-reader") ||
  roles.includes("crm.legacy-internal-client");
